import React, {useMemo} from 'react';
import {ImageItem} from "../ImageSrc";
import styled from "styled-components";

const ImgBox = styled.div`
  position: relative;
`

const AbsoluteBox = styled.div`
  display: flex;
  align-content: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
  right: 0;
  background-color: ${props => props.theme.color.dark_100};
  opacity: 1;
  width: 14px;
  height: 14px;
  border: 1px solid #010101;
  line-height: 11px;

`;
const CounterText = styled.span`
  font-size: 11px;
`;
const StartItemImage = ({list}) => {

    const reduceArray = useMemo(() => {
        if (Array.isArray(list)) {
            return list.reduce((sum, data) => {
                const findIndex = sum.findIndex((findNumber) => Number(findNumber?.itemId) === Number(data));
                if (findIndex > -1) {
                    sum[findIndex] = {
                        ...sum[findIndex],
                        count: sum[findIndex].count + 1
                    }
                } else {
                    sum.push({
                        itemId: Number(data),
                        count: 1,
                    })
                }
                return sum;
            }, [])
        } else {
            return [];
        }
    }, [list]);


    return reduceArray.map((item, index) => {
        return (
            <ImgBox key={item.itemId + "startItem" + index} className={'start-item-box'}>
                <ImageItem itemId={Number(item.itemId)}/>
                {item?.count && item.count > 1 &&
                    <AbsoluteBox>
                        <CounterText>{item.count}</CounterText>
                    </AbsoluteBox>}
            </ImgBox>
        )
    });
};

export default StartItemImage;